import { useCallback, useState } from 'react';

/**
 * Hook for managing search field states in the bao-cao-tinh-trang-don-hang-mua feature
 *
 * This hook manages all SearchField states that are not handled by AritoForm directly.
 * SearchField components use onRowSelection to update these states.
 */
export function useSearchFieldStates() {
  const [customer, setCustomer] = useState<MuaHangRecord>(null);
  const [customerGroup1, setCustomerGroup1] = useState<MuaHangRecord>(null);
  const [customerGroup2, setCustomerGroup2] = useState<MuaHangRecord>(null);
  const [customerGroup3, setCustomerGroup3] = useState<MuaHangRecord>(null);

  const [material, setMaterial] = useState<MuaHangRecord>(null);
  const [materialType, setMaterialType] = useState<MuaHangRecord>(null);
  const [materialGroup1, setMaterialGroup1] = useState<MuaHangRecord>(null);
  const [materialGroup2, setMaterialGroup2] = useState<MuaHangRecord>(null);
  const [materialGroup3, setMaterialGroup3] = useState<MuaHangRecord>(null);

  const [warehouse, setWarehouse] = useState<MuaHangRecord>(null);
  const [lot, setLot] = useState<MuaHangRecord>(null);
  const [location, setLocation] = useState<MuaHangRecord>(null);

  const [transaction, setTransaction] = useState<MuaHangRecord>(null);

  const resetSearchFields = useCallback(() => {
    setCustomer(null);
    setCustomerGroup1(null);
    setCustomerGroup2(null);
    setCustomerGroup3(null);
    setMaterial(null);
    setMaterialType(null);
    setMaterialGroup1(null);
    setMaterialGroup2(null);
    setMaterialGroup3(null);
    setWarehouse(null);
    setLot(null);
    setLocation(null);
    setTransaction(null);
  }, []);

  const getSearchFieldData = useCallback(() => {
    return {
      ma_kh: customer?.uuid || '',
      nh_kh1: customerGroup1?.uuid || '',
      nh_kh2: customerGroup2?.uuid || '',
      nh_kh3: customerGroup3?.uuid || '',

      ma_vt: material?.uuid || '',
      ma_lvt: materialType?.uuid || '',
      nh_vt1: materialGroup1?.uuid || '',
      nh_vt2: materialGroup2?.uuid || '',
      nh_vt3: materialGroup3?.uuid || '',

      ma_kho: warehouse?.uuid || '',
      ma_lo: lot?.ma_lo || '',
      ma_vi_tri: location?.locationCode || '',

      ma_gd: transaction?.transactionCode || ''
    };
  }, [
    customer,
    customerGroup1,
    customerGroup2,
    customerGroup3,
    material,
    materialType,
    materialGroup1,
    materialGroup2,
    materialGroup3,
    warehouse,
    lot,
    location,
    transaction
  ]);

  return {
    customer,
    setCustomer,
    customerGroup1,
    setCustomerGroup1,
    customerGroup2,
    setCustomerGroup2,
    customerGroup3,
    setCustomerGroup3,
    material,
    setMaterial,
    materialType,
    setMaterialType,
    materialGroup1,
    setMaterialGroup1,
    materialGroup2,
    setMaterialGroup2,
    materialGroup3,
    setMaterialGroup3,
    warehouse,
    setWarehouse,
    lot,
    setLot,
    location,
    setLocation,
    transaction,
    setTransaction,

    resetSearchFields,
    getSearchFieldData
  };
}
